import React, { useState, useEffect, useRef } from "react";
import get from "lodash/get";
import { Link } from "@quintype/components";
import { useSelector, useDispatch } from "react-redux";

import { MenuItem } from "../../menu-item";
import MenuRight from "../../../atoms/icons/menu-right";

import { OPEN_SEARCHBAR, OPEN_HAMBURGER_MENU, setNewNotification } from "../../../store/actions";
import Logo from "../../../atoms/icons/logo";
import HamburgerMenus from "../hamburger-menus";
import StickyNavbar from "../../../molecules/sticky-navbar";
import HeaderRight from "../header-right";

import "./mobile-header.m.css";
import Modal from "../../../atoms/modal";
import NotificationBox from "../../../molecules/notification-box";
import CokHeader from "../cok-header";
import { SupportStrip } from "../../../pages/subscribe-page/support-strip";

const MobileHeader = ({
  isHardcodedHeader,
  showStickyNavbar = false,
  showRedirectSupportStrip = false,
  isSubscriber,
}) => {
  const dispatch = useDispatch();

  const getState = useSelector((state) => state);
  const pageType = useSelector((state) => get(state, ["qt", "pageType"], ""));

  const primaryMenus = get(getState, ["qt", "data", "navigationMenu", "primaryMenus"], []);
  const secondaryMenus = get(getState, ["qt", "data", "navigationMenu", "secondaryMenus"], []);
  const isHamburgerMenuOpen = get(getState, ["isHamburgerMenuOpen"], false);
  const [showModal, setShowModal] = useState(false);
  const [hideTheMenu, setHideTheMenu] = useState(true);
  const notificationList = get(getState, "notificationList");

  const openModal = () => setShowModal(true);
  const closeModal = () => setShowModal(false);

  const toggleHandler = () => {
    dispatch({ type: OPEN_HAMBURGER_MENU, isHamburgerMenuOpen: !isHamburgerMenuOpen });
    dispatch({ type: OPEN_SEARCHBAR, isSearchBarOpen: false });
  };

  const primaryBarRef = useRef(null);
  const secondaryRef = useRef(null);
  const fixedPrimaryRef = useRef(null);
  const navbarRef = useRef(null);
  // "flow" | "fixed-top" | "fixed-below"
  const secondaryModeRef = useRef("flow");
  const primaryShownRef = useRef(false);
  const navbarShownRef = useRef(false);
  const pageTypeRef = useRef(pageType);
  const authorBarModeRef = useRef("flow"); // "flow" | "fixed"
  const authorBarTopRef = useRef(null);    // cached document-relative top of #story-author-bar
  const tabulaTopRef = useRef(null);       // cached document-relative top of .ad-wrapper-taboola
  const placeholderRef = useRef(null);     // spacer div that holds layout when author bar is fixed

  useEffect(() => {
    pageTypeRef.current = pageType;
    authorBarTopRef.current = null;
    tabulaTopRef.current = null;
    if (authorBarModeRef.current === "fixed") {
      authorBarModeRef.current = "flow";
      const placeholder = placeholderRef.current;
      placeholderRef.current = null;
      if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
      const el = document.getElementById("story-author-bar");
      if (el) el.style.cssText = "";
    }
  }, [pageType]);

  useEffect(() => {
    let lastY = window.scrollY;
    let ticking = false;

    const showPrimary = (el) => {
      if (primaryShownRef.current) return;
      primaryShownRef.current = true;
      el.style.transform = "translateY(0)";
    };

    const hidePrimary = (el) => {
      if (!primaryShownRef.current) return;
      primaryShownRef.current = false;
      el.style.transform = "translateY(-100%)";
    };

    const showNavbar = (el) => {
      if (navbarShownRef.current) return;
      navbarShownRef.current = true;
      el.style.transform = "translateY(0)";
      const banner = document.getElementById("sticky-ad-banner");
      if (banner) banner.style.transform = `translateY(-${el.offsetHeight}px)`;
    };

    const hideNavbar = (el) => {
      if (!navbarShownRef.current) return;
      navbarShownRef.current = false;
      el.style.transform = "translateY(100%)";
      const banner = document.getElementById("sticky-ad-banner");
      if (banner) banner.style.transform = "translateY(0)";
    };

    const applyFixedTop = (el) => {
      if (secondaryModeRef.current === "fixed-top") return;
      const fromFlow = secondaryModeRef.current === "flow";
      if (fromFlow) {
        el.style.cssText =
          "position:fixed;top:0;left:0;width:100%;z-index:9998;transform:translateY(-100%);transition:none";
      }
      secondaryModeRef.current = "fixed-top";
      if (fromFlow) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            el.style.transition = "transform 0.4s ease";
            el.style.transform = "translateY(0)";
          });
        });
      } else {
        el.style.transform = "translateY(0)";
      }
    };

    const applyFixedBelow = (el) => {
      if (secondaryModeRef.current === "fixed-below") return;
      const fromFlow = secondaryModeRef.current === "flow";
      if (fromFlow) {
        el.style.cssText =
          "position:fixed;top:0;left:0;width:100%;z-index:9998;transform:translateY(-100%);transition:none";
      }
      secondaryModeRef.current = "fixed-below";
      if (fromFlow) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            el.style.transition = "transform 0.6s ease-out";
            el.style.transform = "translateY(74px)";
          });
        });
      } else {
        el.style.transition = "transform 0.6s ease-out";
        el.style.transform = "translateY(74px)";
      }
    };

    const applyFlow = (el, instant = false) => {
      if (secondaryModeRef.current === "flow") return;
      secondaryModeRef.current = "flow";
      if (instant) {
        el.style.cssText = "";
      } else {
        el.style.transform = "translateY(-100%)";
        el.addEventListener("transitionend", function once() {
          el.removeEventListener("transitionend", once);
          if (secondaryModeRef.current === "flow") el.style.cssText = "";
        });
      }
    };

    const fixAuthorBar = (el) => {
      if (authorBarModeRef.current === "fixed") return;
      if (!authorBarTopRef.current) {
        authorBarTopRef.current = el.getBoundingClientRect().top + window.scrollY;
      }
      // Insert a same-height spacer so the surrounding layout doesn't collapse
      const placeholder = document.createElement("div");
      placeholder.style.cssText = `height:${el.offsetHeight}px;visibility:hidden;pointer-events:none;`;
      el.parentNode.insertBefore(placeholder, el);
      placeholderRef.current = placeholder;
      el.style.cssText =
        "position:fixed;top:0;left:0;width:calc(100% - 32px);z-index:9998;transform:translateY(-100%);transition:none;margin:0 16px;";
      authorBarModeRef.current = "fixed";
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          el.style.transition = "transform 0.4s ease";
          el.style.transform = "translateY(0)";
        });
      });
    };

    const releaseAuthorBar = () => {
      if (authorBarModeRef.current === "flow") return;
      authorBarModeRef.current = "flow";
      const el = document.getElementById("story-author-bar");
      const placeholder = placeholderRef.current;
      placeholderRef.current = null;
      // Remove placeholder first (el is still fixed, so no visual shift)
      if (placeholder && placeholder.parentNode) placeholder.parentNode.removeChild(placeholder);
      // Then snap el back to natural flow (its natural position is always ≥ viewport top at this point)
      if (el) el.style.cssText = "";
    };

    const handleScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          const currentScrollY = window.scrollY;
          const nearBottom =
            currentScrollY + window.innerHeight >= document.documentElement.scrollHeight - 80;
          setHideTheMenu(!nearBottom);
          const diff = currentScrollY - lastY;

          if (Math.abs(diff) >= 5) {
            const scrollingUp = diff < 0;
            const pastHeader = currentScrollY > 74;
            const nearBottomBuffer =
              currentScrollY + window.innerHeight >= document.documentElement.scrollHeight - 100;
            const sec = secondaryRef.current;
            const pri = fixedPrimaryRef.current;
            const nav = navbarRef.current;
            const isStoryPage = pageTypeRef.current === "story-page";
            const authorEl = isStoryPage ? document.getElementById("story-author-bar") : null;

            if (nearBottom) {
              releaseAuthorBar();
              if (pri) showPrimary(pri);
              if (sec) applyFixedBelow(sec);
              if (nav) showNavbar(nav);
            } else if (scrollingUp && pastHeader) {
              if (pri) hidePrimary(pri);
              if (nav) showNavbar(nav);
              if (isStoryPage && authorEl) {
                if (!tabulaTopRef.current) {
                  const tabulaEl = document.getElementById("ad-wrapper-taboola");
                  if (tabulaEl) tabulaTopRef.current = tabulaEl.getBoundingClientRect().top + currentScrollY;
                }
                if (!authorBarTopRef.current) {
                  authorBarTopRef.current = authorEl.getBoundingClientRect().top + currentScrollY;
                }
                const pastTabula = tabulaTopRef.current && currentScrollY < tabulaTopRef.current;
                const authorBarTop = authorBarTopRef.current;
                const authorBarReleaseBuffer = 8;
                const reachedAuthorBar =
                  typeof authorBarTop === "number" && currentScrollY <= authorBarTop + authorBarReleaseBuffer;
                if (reachedAuthorBar) {
                  releaseAuthorBar();
                  // Secondary-stack only appears after 77px more of upward scroll
                  if (typeof authorBarTop === "number" && currentScrollY <= authorBarTop - 77) {
                    if (sec) applyFixedTop(sec);
                  }
                } else if (pastTabula) {
                  if (sec) applyFlow(sec, false);
                  fixAuthorBar(authorEl);
                } else {
                  if (authorBarModeRef.current === "fixed") releaseAuthorBar();
                  if (sec) applyFixedTop(sec);
                }
              } else {
                if (sec) applyFixedTop(sec);
              }
            } else if (nearBottomBuffer && secondaryModeRef.current !== "flow") {
              releaseAuthorBar();
              if (pri) hidePrimary(pri);
              if (sec) applyFixedTop(sec);
              if (nav) showNavbar(nav);
            } else {
              if (authorBarModeRef.current === "fixed") releaseAuthorBar();
              if (pri) hidePrimary(pri);
              if (sec) applyFlow(sec, scrollingUp);
              if (nav) hideNavbar(nav);
            }

            lastY = currentScrollY;
          }

          ticking = false;
        });
        ticking = true;
      }
    };

    const onContentExpanded = () => {
      tabulaTopRef.current = null;
      authorBarTopRef.current = null;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("dh-content-expanded", onContentExpanded);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("dh-content-expanded", onContentExpanded);
    };
  }, []);

  const isModalOpen = get(getState, ["isModalOpen"], false);
  useEffect(() => {
    const el = primaryBarRef.current;
    if (!el) return;
    el.style.height = isModalOpen ? "100dvh" : "74px";
  }, [isModalOpen]);

  useEffect(() => {
    if (showModal) {
      window.localStorage.setItem("latestNotificationCreatedAt", notificationList[0]?.createdAt);
      dispatch(setNewNotification(false));
    }
  }, [showModal]);

  const getPrimaryMenus = () => (
    <div styleName="primary-menus">
      {primaryMenus.slice(0, 10).map((item, index) => (
        <div key={index} styleName="primary-menu-item">
          <MenuItem
            changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
            changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
            item={item}
            menuStyle="menu-link"
            toggleHandler={() => dispatch({ type: OPEN_SEARCHBAR, isSearchBarOpen: false })}
          />
        </div>
      ))}
    </div>
  );

  if (isHardcodedHeader == "cok2025") {
    return <CokHeader toggleHandler={toggleHandler} />;
  }

  return (
    <>
      <div styleName="header" id="mob-header">
        <div ref={primaryBarRef} styleName="primary">
          <div>
            <Link href="/" styleName="logo">
              <Logo height="56" width="64.63" />
            </Link>
          </div>
          <div styleName="primary-right-wrapper">
            <HeaderRight openNotificationModal={openModal} isSubscriber={isSubscriber} />
          </div>
        </div>
        {showModal && (
          <Modal onClose={closeModal} isOpen={showModal}>
            <NotificationBox closeBtnHandler={closeModal} />
          </Modal>
        )}
      </div>
      <div ref={secondaryRef} styleName="secondary-stack" id="secondary-menu-stack">
        <div styleName="secondary" className="primary-menu">
          <div>{getPrimaryMenus()}</div>
        </div>
        <div styleName="menu-wrapper secondary-menu-wrapper" className="secondary-menu">
          {secondaryMenus.slice(0, 10).map((item, index) => (
            <React.Fragment key={index}>
              <div styleName="secondary-menu-item">
                <MenuRight />
                <MenuItem
                  item={item}
                  key={index}
                  type="secondary"
                  menuStyle="menu-link"
                  changeTextColor={item?.data?.color.toLowerCase() !== "#ffffff"}
                  changeTextWeight={item?.data?.color.toLowerCase() !== "#ffffff"}
                />
              </div>
            </React.Fragment>
          ))}
        </div>
      </div>
      <div ref={fixedPrimaryRef} styleName="fixed-primary">
        <div styleName="header">
          <div styleName="primary">
            <div>
              <Link href="/" styleName="logo">
                <Logo height="56" width="64.63" />
              </Link>
            </div>
            <div styleName="primary-right-wrapper">
              <HeaderRight openNotificationModal={openModal} hideTheMenu={hideTheMenu} isSubscriber={isSubscriber} />
            </div>
          </div>
        </div>
      </div>
      { showRedirectSupportStrip && <SupportStrip />}
      <HamburgerMenus />
      <StickyNavbar navbarRef={navbarRef} showStickyNavbar={showStickyNavbar} onMenuToggle={() => toggleHandler()} />
    </>
  );
};

export default MobileHeader;
